import { EFinancingProgram } from '@if/core/types'
import { type DefaultError, MutationFunction, UseMutateAsyncFunction, useMutation } from '@tanstack/react-query'
import { getApiClient } from '../api-client'
import { CreditApplicationParams, SendUploadDocumentRequestResultDto } from '../type'

export const sendUploadDocumentRequest: MutationFunction<
  SendUploadDocumentRequestResultDto,
  CreditApplicationParams
> = async ({ creditApplicationId, financingProgramId }) => {
  const apiClient = getApiClient()
  const response = await apiClient.post<SendUploadDocumentRequestResultDto>(
    `/Document/${financingProgramId}/${creditApplicationId}/SendUploadDocumentRequest`,
  )
  return response.data
}

export function useSendUploadDocumentRequest(
  creditApplicationId: string,
  financingProgramId: EFinancingProgram,
): [
  UseMutateAsyncFunction<SendUploadDocumentRequestResultDto, DefaultError, void, unknown>,
  boolean,
  boolean,
  boolean,
] {
  const { mutateAsync, isPending, isError, isSuccess } = useMutation<
    SendUploadDocumentRequestResultDto,
    DefaultError,
    void
  >({
    // creditApplicationId and financingProgramId are captured via closure; mutateAsync takes no arguments at the call site.
    mutationFn: () => sendUploadDocumentRequest({ creditApplicationId, financingProgramId }),
  })
  return [mutateAsync, isPending, isError, isSuccess]
}
